/* HALAL CALGARY - BOOT
 *
 * The one blocking script in <head>, loaded first on every page (public site,
 * admin, sign-in). It does what cannot wait for the end of <body>: apply the
 * theme before first paint (main.css has no prefers-color-scheme fallback),
 * start the map's data and basemap header requests during the parse, and
 * promote async stylesheets as they land. External rather than inline so it
 * caches and needs no CSP nonce; synchronous on purpose, so keep it small.
 *
 * Nothing here is load-bearing: without it the page paints light, the map
 * fetches its own data later, and the <noscript> stylesheet copies apply. */
(function () {
  var root = document.documentElement;

  /* A PAGE WITH A MAP. map-app is on <html> on every public page (it scopes
   * main.css's no-page-zoom rules); an article page also carries
   * articles-mode, and has no map: no place data to ask for and no
   * halalcalgary:ready to wait for. */
  var hasMap = root.classList.contains('map-app') && !root.classList.contains('articles-mode');

  /* JAVASCRIPT IS RUNNING.
   * main.css only fades lazy images in under .js - see "html:not(.js)" there -
   * so with scripting off they are simply visible. */
  root.classList.add('js');

  /* STRIPS DISMISSED EARLIER IN THE VISIT.
   * Read before first paint so a dismissed strip never paints and then
   * collapses (layout shift). html.hc-hide-<name> hides it in main.css;
   * app.js owns the state from there - see "DISMISSABLE STRIPS". Storage
   * throws in private windows and with blocked site data. */
  ['announcements', 'featured'].forEach(function (name) {
    try {
      if (sessionStorage.getItem('hc:strip-dismissed:' + name) === '1') root.classList.add('hc-hide-' + name);
    } catch (e) { /* no storage: nothing was dismissed */ }
  });

  /* THEME.
   *   1. A saved choice beats the OS setting.
   *   2. With none, follow the OS live - re-checked on visibilitychange and
   *      pageshow because matchMedia's event is unreliable for backgrounded
   *      and bfcached tabs.
   *   3. Toggling to match the OS CLEARS the saved choice, so one toggle does
   *      not opt the browser out of following the OS forever.
   * Page scripts call window.__halalCalgarySetTheme and listen for the
   * halalcalgary:theme event to update what CSS cannot reach (icons, tile
   * URLs, canvas charts). */
  var KEY = 'halalCalgaryDarkMode';

  function query() {
    return window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  }

  function systemDark() {
    var q = query();
    return !!(q && q.matches);
  }

  function stored() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'true' ? true : v === 'false' ? false : null;
    } catch (err) {
      // Storage blocked: treat as no saved choice so the OS still applies.
      return null;
    }
  }

  function apply(dark) {
    root.classList.toggle('dark', dark);
    window.__halalCalgaryDarkModePreferred = dark;
    try {
      window.dispatchEvent(new CustomEvent('halalcalgary:theme', { detail: { dark: dark } }));
    } catch (err) {}
  }

  var saved = stored();
  apply(saved === null ? systemDark() : saved);

  window.__halalCalgarySetTheme = function (dark) {
    try {
      if (dark === systemDark()) {
        localStorage.removeItem(KEY);
      } else {
        localStorage.setItem(KEY, String(dark));
      }
    } catch (err) {
      // Not remembered across visits; still correct for this page view.
    }
    apply(dark);
  };

  function follow() {
    if (stored() !== null) return;

    var dark = systemDark();
    if (dark !== root.classList.contains('dark')) apply(dark);
  }

  var q = query();
  if (q) {
    if (q.addEventListener) {
      q.addEventListener('change', follow);
    } else if (q.addListener) {
      // Safari < 14.
      q.addListener(follow);
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) follow();
  });

  window.addEventListener('pageshow', follow);

  /* ASYNC STYLESHEETS.
   * partials/async-style emits <link rel="preload" as="style" data-async>;
   * flip it to a stylesheet when it loads. load does not bubble, hence the
   * capture phase. data-async is removed first because some browsers fire
   * load again when rel flips. */
  document.addEventListener('load', function (event) {
    var link = event.target;

    if (!link || link.tagName !== 'LINK' || !link.hasAttribute('data-async')) return;

    link.removeAttribute('data-async');
    link.rel = 'stylesheet';
  }, true);

  /* ANALYTICS, AFTER THE PAGE HAS SETTLED.
   * The layout names the vendor script in <meta name="hc-analytics-src">;
   * it is added once the page has loaded and, on the map, once main.js says
   * the map has finished starting up (halalcalgary:ready, as the splash
   * goes), then when the browser is idle. Loaded at load alone it arrived in
   * the middle of building the markers and the list. The inline snippet has
   * already queued the page view in gtag's dataLayer, and events queue there
   * too until the script arrives. */
  var analytics = document.querySelector('meta[name="hc-analytics-src"]');

  if (analytics && analytics.content) {
    var pageLoaded = false;
    var mapReady = !hasMap;
    var analyticsAdded = false;

    var addAnalytics = function () {
      if (analyticsAdded) return;
      analyticsAdded = true;

      var s = document.createElement('script');

      s.async = true;
      s.src = analytics.content;
      // dom.js is not loaded yet when this file runs, but this only ever runs
      // after window load, by which time it is.
      dom.insert(document.head, s);
    };

    var maybeAddAnalytics = function () {
      if (!pageLoaded || !mapReady || analyticsAdded) return;

      if (window.requestIdleCallback) {
        window.requestIdleCallback(addAnalytics, { timeout: 3000 });
      } else {
        setTimeout(addAnalytics, 1);
      }
    };

    window.addEventListener('halalcalgary:ready', function () {
      mapReady = true;
      maybeAddAnalytics();
    });

    window.addEventListener('load', function () {
      pageLoaded = true;
      maybeAddAnalytics();

      // A map that never gets ready (its data never came) still counts.
      setTimeout(function () {
        mapReady = true;
        maybeAddAnalytics();
      }, 10000);
    });
  }

  /* THE MAP'S DATA, STARTED EARLY.
   * Stores the PROMISE; app.js uses it if present and otherwise fetches
   * itself (with its own retries), so failure only loses the head start. The
   * rejection is swallowed so it is not reported before app.js attaches.
   * The token meta precedes this script; article pages have the token but no
   * map (see hasMap above). */
  var meta = document.querySelector('meta[name="hc-token"]');

  if (meta && hasMap && typeof fetch === 'function') {
    try {
      window.__hcPlaces = fetch('/api/places.php', {
        cache: 'no-store',
        // Ahead of the thumbnails: the splash waits on this.
        priority: 'high',
        headers: { 'X-HC-Token': meta.content },
      });

      window.__hcPlaces.catch(function () {});
    } catch (err) {
      // app.js fetches the ordinary way.
    }
  }

  /* THE BASEMAP'S HEADER, STARTED EARLY.
   * protomaps reads the vector archive's first 16KB (its header and root
   * directory) before it can draw a tile, but only once app.js has made the
   * layer - on a phone about 750 ms after the HTML. The layout names the
   * archive in <meta name="hc-basemap-archive"> only on map pages with a
   * vector basemap, so the meta is the guard. After the place data above,
   * which the splash waits on, so that reaches the server first.
   * Stores { url, bytes }: bytes is a promise of the response in the shape
   * protomaps' own fetch returns, or of null when the request failed or the
   * server ignored the Range - a 200 is the whole archive, so it is cut off
   * at once rather than left streaming. app.js hands protomaps these bytes
   * ("THE BASEMAP'S FIRST 16KB" there) or, given null, lets it fetch its
   * own; failure only loses the head start. They are used within this page
   * load and kept nowhere. */
  var tileArchive = document.querySelector('meta[name="hc-basemap-archive"]');

  if (tileArchive && tileArchive.content && typeof fetch === 'function') {
    try {
      var ua = navigator.userAgent || '';
      var stopTiles = typeof AbortController === 'function' ? new AbortController() : null;

      window.__hcTileHead = {
        url: tileArchive.content,
        bytes: fetch(tileArchive.content, {
          headers: { Range: 'bytes=0-16383' },
          // As protomaps' own request does: Chromium on Windows mis-serves cached ranges.
          cache: ua.indexOf('Windows') > -1 && /Chrome|Chromium|Edg|OPR|Brave/.test(ua) ? 'no-store' : undefined,
          signal: stopTiles ? stopTiles.signal : undefined,
        }).then(function (res) {
          if (res.status !== 206) {
            if (stopTiles) stopTiles.abort();

            return null;
          }

          return res.arrayBuffer().then(function (data) {
            var etag = res.headers.get('ETag');

            return {
              data: data,
              // protomaps ignores a weak ETag too.
              etag: etag && etag.indexOf('W/') !== 0 ? etag : undefined,
              cacheControl: res.headers.get('Cache-Control') || undefined,
              expires: res.headers.get('Expires') || undefined,
            };
          });
        }).catch(function () {
          return null;
        }),
      };
    } catch (err) {
      // protomaps fetches the header itself.
    }
  }
})();
